import { Reducer } from 'redux';
import { isType } from 'typescript-fsa';
import { describeDocumentActions ,updateDocumentActions} from './document.action';
import { lensPath, pathOr, set, values } from 'ramda';
import { createDefaultState, onCreateOrUpdate, onGetAllSuccess, onStart } from '../store.helpers';
import {
  EntityError,
  MappedEntityState2 as MappedEntityState,
} from 'src/store/types';
import { compose } from 'recompose';

export type State = MappedEntityState<any, EntityError>;

export const defaultState: State = createDefaultState();

const reducer: Reducer<State> = (state = defaultState, action) => {
   
    if (isType(action, describeDocumentActions.started)) {
       return onStart(state);
    }
    if (isType(action, describeDocumentActions.done)) {
        const { payload } = action;
        const documents = pathOr({},['result','data'],payload)
       const data = onGetAllSuccess(
        // TO-DO: Why are we sending 2 paramters of the same.
        // Well refer the onGetAllSuccess to study further
        pathOr([], ['items'], documents),
        state,
        pathOr([], ['items'], documents)
      );
      return getDocuments(data);
    }
    if (isType(action, updateDocumentActions.done)) {
      const { payload } = action;
      const data = onCreateOrUpdate(pathOr({}, ['result'], payload), state)
      return getDocuments(data);
    }

  return state;
};

const getDocuments = (data:any) =>{
 return compose(
    set(
      lensPath(['documents']),
      values(pathOr([],['itemsById'],data))
    ),
  )(data)
}

export default reducer;
